import { remarksSchema } from './common';
import {
  endsAtSchema,
  lastUpdatedAtSchema,
  regexSchema,
  startsAtSchema,
} from './company';
import { halfWidthNumber } from './regex';

import { TerminalTypeKey } from '@/types';
import {
  InferType,
  boolean,
  object,
  string,
} from '@/validations/custom-yup';

/** 外部端末ID */
export const externalTerminalIdSchema = string()
  .label('外部端末ID')
  .notRequired()
  .max(100)
  .when(
    'regex',
    ([regex], schema) => (regex ? schema.matches(regex, '外部端末IDのフォーマットを確認してください。') : schema),
  );

/** 端末種別 */
export const terminalTypeSchema = string<TerminalTypeKey>()
  .label('端末種別')
  .required(({ label }) => `${label}を選択してください。`);

/** 端末パスワード */
export const terminalPasswordSchema = string()
  .label('端末パスワード')
  .when('canEditTerminalPassword', {
    is: true,
    then: (it) => it
      .length(4, '端末パスワードは4桁で入力してください。')
      .matches(halfWidthNumber, '端末パスワードは半角数字で入力してください。')
      .required(),
    otherwise: (it) => it.notRequired(),
  });

/** 店舗ID */
export const shopIdSchema = string()
  .label('店舗ID');

/** デフォルト端末 */
export const defaultTerminalSchema = boolean()
  .label('デフォルト端末')
  .required();

/** 端末ステッカーID */
export const terminalStickerIdSchema = string()
  .label('端末ステッカーID')
  .notRequired()
  .test(
    'isLength6',
    '端末ステッカーIDは6文字で入力してください。',
    (value) => (value ? value.length === 6 : true),
  );

/** 端末パスワードを編集可能かどうか */
export const canEditTerminalPasswordSchema = boolean()
  .defined()
  .default(false);

export const terminalEditFormSchema = object({
  externalId: externalTerminalIdSchema,
  terminalType: terminalTypeSchema,
  terminalPassword: terminalPasswordSchema,
  shopId: shopIdSchema,
  startsAt: startsAtSchema,
  endsAt: endsAtSchema,
  defaultTerminal: defaultTerminalSchema,
  terminalStickerId: terminalStickerIdSchema,
  remarks: remarksSchema(),
  regex: regexSchema,
  lastUpdatedAt: lastUpdatedAtSchema,
  canEditTerminalPassword: canEditTerminalPasswordSchema,
});

export type TerminalEditForm = InferType<typeof terminalEditFormSchema>;
